import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';

const tabHeight = 32;
const useStyles = makeStyles({
  tabsRoot: {
    minHeight: tabHeight,
    height: tabHeight,
  },
  tabRoot: {
    minHeight: tabHeight,
    height: tabHeight,
    minWidth: 120,
    lineHeight: 0.9,
    textTransform: 'none',
  }
});

const TabPanel = (props) => {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box pt={0.5} pb={0.5}>
            {children}
          </Box>
        )}
      </div>
    );
}

const CustomTab = (props) => {
  const { children, labels, defaultValue, ...other } = props;
  const classes = useStyles();
  const [value, setValue] = React.useState(defaultValue || 0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div>
        <Paper square>
            <Tabs
              className={classes.tabsRoot}
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              {...other}
            >
              {labels.map((l, index) => <Tab key={index} className={classes.tabRoot} {...l} ></Tab>)}
            </Tabs>
        </Paper>

        {children.map((child, index) => 
          <TabPanel key={index} value={value} index={index}>{child}</TabPanel>)
        }
    </div>
  );
}

export default CustomTab;
